import { useEffect } from "react"

import * as turf from "@turf/turf"

import { FIT_TO_BOUNDING_BOX_DURATION, MAP_TYPE_NETWORK, useMapContext } from "@l2r-front/l2r-map"

import { useNetworksStateContext } from "../../contexts/NetworksContext"


export const MapAdapterBoundingBox = () => {

    const { selectedNetwork } = useNetworksStateContext()
    const [mapState, mapDispatch] = useMapContext()
    const { storedBoundingBox } = mapState
    const { getMapRef, setMapType, setMapBoundingBoxToFit, restoreMapBoundingBox } = mapDispatch
    const mapRef = getMapRef()

    useEffect(() => {
        setMapType(MAP_TYPE_NETWORK)
    }, [setMapType])

    useEffect(() => {
        if (mapRef) {
            if (storedBoundingBox.network) {
                restoreMapBoundingBox(MAP_TYPE_NETWORK, { duration: FIT_TO_BOUNDING_BOX_DURATION })
            } else {
                const [minLng, minLat, maxLng, maxLat] = turf.bbox(selectedNetwork.boundingBox)
                setMapBoundingBoxToFit({
                    minLng,
                    minLat,
                    maxLng,
                    maxLat,
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapRef, selectedNetwork.boundingBox])

    return null
}